import axios from './index'

export default {
  fetch(params) {
    return axios.get('/api/v1/report/task', { params })
  },
  fetchDuration(params) {
    return axios.get('/api/v1/report/task/duration', { params })
  },
}